// src/lib/locationLoaders.js
import * as queries from "../graphql/queries";

/**
 * These functions assume you pass in a gql(query, vars) helper
 * (like the one you already have in AddDevice/EditDevice).
 */

export async function fetchProperties({ gql, tenantKey, limit = 200 }) {
  if (!tenantKey) return [];
  const data = await gql(queries.propertiesByTenantName, {
    tenantKey,
    limit,
    sortDirection: "ASC",
  });
  return data?.propertiesByTenantName?.items ?? [];
}

export async function fetchBuildingsForProperty({
  gql,
  tenantKey,
  propertyId,
  limit = 500,
}) {
  if (!tenantKey || !propertyId) return [];
  const data = await gql(queries.buildingsByTenantPropertyCode, {
    tenantKey,
    propertyIdCode: {
      beginsWith: { propertyId },
    },
    sortDirection: "ASC",
    limit,
  });
  return data?.buildingsByTenantPropertyCode?.items ?? [];
}

export async function fetchUnitsForBuilding({
  gql,
  tenantKey,
  buildingId,
  pageLimit = 500,
  hardCap = 5000,
}) {
  if (!tenantKey || !buildingId) return [];

  const collected = [];
  let nextToken = null;

  do {
    const data = await gql(queries.unitsByTenantBuildingCode, {
      tenantKey,
      buildingIdCode: { beginsWith: { buildingId } },
      sortDirection: "ASC",
      limit: pageLimit,
      nextToken,
    });

    const page = data?.unitsByTenantBuildingCode?.items ?? [];
    nextToken = data?.unitsByTenantBuildingCode?.nextToken ?? null;

    collected.push(...page);
    if (collected.length >= hardCap) nextToken = null;
  } while (nextToken);

  return collected;
}
